import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { savingNodesPositions } from '../actions/scrolling';
import Gallery from '../components/Gallery';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavigationBar from '../components/NavigationBar';
import Contact from '../components/Contact';
import AboutArtisto from '../components/artisto/AboutArtisto';
import Menu from '../components/Menu';
import Events from '../components/Events';
import { getMenuBySlug } from '../actions/MenusAction';
import { getEventsBySlug } from '../actions/EventsAction';
import { getGallery } from '../actions/GallerieAction';
import HeaderWithBooking from '../components/leqg/HeaderWithBooking';
import Icon from '../assets/images/logo/artisto-logo.svg';

class Lartisto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: [],
      images: [],
      items: [],
    };
  }

  componentDidMount() {
    this.props.getGallery('lartistosousse');
    this.props.getEventsBySlug('lartistosousse');
    this.props.getMenuBySlug('lartistosousse');
    const about = ReactDOM.findDOMNode(this.refs.about);
    const events = ReactDOM.findDOMNode(this.refs.events);
    const menu = ReactDOM.findDOMNode(this.refs.menu);
    const gallery = ReactDOM.findDOMNode(this.refs.gallery);

    this.props.savingNodesPositions({
      lartisto: {
        about: about.offsetTop,
        events: events.offsetTop,
        menu: menu.offsetTop,
        gallery: gallery.offsetTop,
      },
    });
  }

  render() {
    return (
      <Fragment>
        <Header
          content={
            <HeaderWithBooking
              icon={<img alt="Logo" className="m-2" src={Icon} style={{ height: 250 }} />}
              eventsBooking={this.props.events}
            />
          }
          background="artisto-header-bg"
        >
          <NavigationBar
            slug="lartisto"
            navigations={[
              { name: 'about', txt: 'About' },
              { name: 'events', txt: 'Events' },
              { name: 'menu', txt: 'Menu' },
              { name: 'gallery', txt: 'Gallery' },
            ]}
          />
        </Header>
        <AboutArtisto ref="about" background="artisto-about-bg" />
        <Events ref="events" background="artisto-event-bg" data={this.props.events} />
        <Menu ref="menu" background="artisto-menu-bg" color="yellow" data={this.props.menus} />
        <Gallery ref="gallery" background="artisto-gallery-bg" medias={this.props.gallerie} />
        <Contact ref="contact" minimal color="#fff3b8" placeholders="#fffcd3" background="artisto-about-bg" info={info} />
        <Footer color="#ceb688" secondColor="#7a7458" />
      </Fragment>
    );
  }
}

const info = {
  facebook: 'https://www.facebook.com/lartistoresto/',
  insta: 'https://www.instagram.com/explore/locations/979725783/lartisto/',
  youtube: '',
  tripAdvisor:
    'https://www.tripadvisor.fr/Restaurant_Review-g297952-d5617378-Reviews-L_ARTISTO-Port_El_Kantaoui_Sousse_Governorate.html',
  address: <span>SOCIETE " G A S " SARL 6ET, IMM "VENUS" A 6-4, Golf Advanced Services, 1082 CENTRE URB NORD</span>,
};

export default connect(
  store => ({
    scrolling: store.scrolling,
    menus: store.menus,
    gallerie: store.gallerie,
    events: store.events,
  }),
  {
    savingNodesPositions,
    getMenuBySlug,
    getEventsBySlug,
    getGallery,
  }
)(Lartisto);



// WEBPACK FOOTER //
// ./src/pages/lartistosousse.jsx